// 環境設定エントリーポイント
// 環境に応じて env_production.js または env_local.js を読み込む

const env = process.env.NODE_ENV || 'local';

let config;

switch (env) {
  case 'production':
    config = require('./env_production').default;
    break;
  case 'local':
  default:
    config = require('./env_local').default;
    break;
}

export default config;
